// extracted by mini-css-extract-plugin
export var linkAvatar = "LinkAvatar_linkAvatar__temv3";
export var activePage = "LinkAvatar_activePage__VzSNw";
export var backgroundDark = "LinkAvatar_backgroundDark__nNDnI";
export var imgAvatar = "LinkAvatar_imgAvatar__+db0I";
export var rotate = "LinkAvatar_rotate__je8kY";
export var dotty = "LinkAvatar_dotty__3g4zq";